import gql from 'graphql-tag'

import { UserPlanFragment } from '../../../../graphql/fragments/UserPlanFragment'
import { Day, Moment } from '../../../../types/fam-graphql'
import { mutationServiceCreator } from '../../../../helpers/GraphqlHelpers'

const mutation = gql`
  mutation replaceRecipeInPlan(
    $plan: ID!
    $day: Day!
    $moment: Moment!
    $previous: ID!
    $recipe: ID!
  ) {
    replaceRecipeInPlan(
      plan: $plan
      day: $day
      moment: $moment
      previous: $previous
      recipe: $recipe
    ) {
      ...UserPlanFragment
    }
  }
  ${UserPlanFragment}
`

const transformer = ({ replaceRecipeInPlan }: any) => replaceRecipeInPlan

type variables = {
  plan: string
  day: Day
  regime: Moment
  previous: string
  recipe: string
}

export default mutationServiceCreator<variables>(mutation, transformer)
